import(/* webpackMode: "eager", webpackExports: ["SizeGuideNew"] */ "/hisea-ssr/src/components/size-guide-new/index.tsx");
